export default "__VITE_ASSET__uVpoZENm__"